import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from '../lib/utils.js';
function Skeleton({ className, ...props }) {
    return (_jsx("div", { className: cn('animate-pulse rounded-md bg-black/10 dark:bg-white/10', className), ...props }));
}
export { Skeleton };
//# sourceMappingURL=skeleton.js.map